// import React, { useEffect, useState } from "react";
// import { toast } from "../../components/AppToast";
// import WorkstationList from "./WorkstationList";
// import CreateWorkstation from "./CreateWorkstation";
// import {
//     fetchWorkstation,
//     createWorkstation,
//     updateWorkstation
// } from "../../services/workstation/workstation.service";

// export default function WorkstationManagement() {

//     const [wsData, setWsData] = useState();
//     const [isCreating, setIsCreating] = useState(false);
//     const [activeRecord, setActiveRecord] = useState(null);

//     const [page, setPage] = useState(0);
//     const [pageSize, setPageSize] = useState(10);

//     const onlyFormVisible = isCreating || !!activeRecord;

//     const closeForm = () => {
//         setIsCreating(false);
//         setActiveRecord(null);
//     };

//     useEffect(() => {
//         fetchData();
//     }, [page, pageSize]);

//     const fetchData = async () => {
//         const result = await fetchWorkstation(page, pageSize);
//         setWsData(result);
//     };

//     const submitForm = async (formData, id) => {
//         try {

//             if (id) {
//                 await updateWorkstation(id, formData);
//                 toast.success("Workstation updated successfully");
//             } else {
//                 await createWorkstation(formData);
//                 toast.success("Workstation created successfully");
//             }

//             closeForm();
//             fetchData();

//         } catch (err) {
//             toast.error(err.message);
//         }
//     };

//     return (
//         <div className="card shadow-lg main-card">

//             <div className="card-header bg-secondary text-white">
//                 <h4 className="mb-0 h6 fw-semibold">
//                     {!onlyFormVisible
//                         ? "Workstation Management"
//                         : isCreating
//                             ? "Create Workstation"
//                             : activeRecord?.mode === "edit"
//                                 ? "Edit Workstation"
//                                 : "View Workstation"}
//                 </h4>
//             </div>

//             <div className="card-body">

//                 {!onlyFormVisible ? (
//                     <WorkstationList
//                         workstation={wsData}
//                         page={page}
//                         pageSize={pageSize}
//                         setPage={setPage}
//                         setPageSize={setPageSize}
//                         onCreateClick={() => setIsCreating(true)}
//                         onView={(row) => setActiveRecord({ mode: "view", data: row })}
//                         onEdit={(row) => setActiveRecord({ mode: "edit", data: row })}
//                         onRefresh={fetchData}
//                     />
//                 ) : (
//                     <CreateWorkstation
//                         initialValues={activeRecord?.data || {}}
//                         onCancel={closeForm}
//                         onSubmit={submitForm}
//                         viewOnly={activeRecord?.mode === "view"}
//                         isEdit={activeRecord?.mode === "edit"}
//                     />
//                 )}

//             </div>
//         </div>
//     );
// }



import React, { useEffect, useState } from "react";
import { toast } from "../../components/AppToast";
import WorkstationList from "./WorkstationList";
import CreateWorkstation from "./CreateWorkstation";
import {
    fetchWorkstation,
    createWorkstation,
    updateWorkstation
} from "../../services/workstation/workstation.service";

export default function WorkstationManagement() {

    const [wsData, setWsData] = useState();
    const [isCreating, setIsCreating] = useState(false);
    const [activeRecord, setActiveRecord] = useState(null);

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const onlyFormVisible = isCreating || !!activeRecord;

    const closeForm = () => {
        setIsCreating(false);
        setActiveRecord(null);
    };

    useEffect(() => {
        fetchData();
    }, [page, pageSize]);

    const fetchData = async () => {
        try {
            const result = await fetchWorkstation(page, pageSize);
            setWsData(result);
        } catch (err) {
            console.error(err);
        }
    };

    const submitForm = async (formData, id) => {
        try {
            if (id) {
                await updateWorkstation(id, formData);
                toast.success("Workstation updated successfully");
            } else {
                await createWorkstation(formData);
                toast.success("Workstation created successfully");
            }

            closeForm();
            fetchData();

        } catch (err) {
            toast.error(err.message);
        }
    };

    return (
        <div className="card shadow-lg main-card">

            {/* Header */}
            <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
                <h4 className="mb-0 h6 fw-semibold">
                    {!onlyFormVisible
                        ? "Workstation Management"
                        : isCreating
                            ? "Create Workstation"
                            : activeRecord?.mode === "edit"
                                ? "Edit Workstation"
                                : "View Workstation"}
                </h4>
            </div>

            {/* Breadcrumb */}
            {onlyFormVisible && (
                <nav className="px-3 py-2 border-bottom bg-light">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                            <button
                                className="btn btn-link p-0 text-decoration-none text-muted"
                                onClick={closeForm}
                            >
                                Workstation Management
                            </button>
                        </li>
                        <li className="breadcrumb-item active text-primary fw-semibold">
                            {isCreating
                                ? "Create Workstation"
                                : activeRecord?.mode === "edit"
                                    ? "Edit Workstation"
                                    : "View Workstation"}
                        </li>
                    </ol>
                </nav>
            )}

            {/* Body */}
            <div className="card-body">
                {!onlyFormVisible ? (
                    <WorkstationList
                        workstation={wsData}
                        page={page}
                        pageSize={pageSize}
                        setPage={setPage}
                        setPageSize={setPageSize}
                        onCreateClick={() => setIsCreating(true)}
                        onView={(row) => setActiveRecord({ mode: "view", data: row })}
                        onEdit={(row) => setActiveRecord({ mode: "edit", data: row })}
                        onRefresh={fetchData}
                    />
                ) : (
                    <CreateWorkstation
                        initialValues={activeRecord?.data || {}}
                        onCancel={closeForm}
                        onSubmit={submitForm}
                        viewOnly={activeRecord?.mode === "view"}
                        isEdit={activeRecord?.mode === "edit"}
                    />
                )}
            </div>
        </div>
    );
}